
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ManagersList/ManagersList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ManagersList.html');
        
        var script = require('./ManagersList.ts').default;
        module.exports = require('./ManagersList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    